export const init = (id, defaultPageSize, defaultSorting) => ({
  type: 'INIT_SSPLIST',
  id,
  defaultPageSize,
  defaultSorting,
});

export const listRequest = (id) => ({
  type: 'LIST_REQUEST',
  id,
});

export const setListExporting = (id, isExporting) => ({
  type: 'SET_LIST_EXPORTING',
  payload: { id, isExporting },
});

export const listRequestSuccess = (id, data) => ({
  type: 'LIST_REQUEST_SUCCESS',
  id,
  data,
});

export const listRequestError = (id, error) => ({
  type: 'LIST_REQUEST_ERROR',
  id,
  error,
});

export const listClearData = (id) => ({
  type: 'LIST_CLEAR_DATA',
  id,
});

export const changePageOrSize = (id, pageToken, pageSize) => ({
  type: 'CHANGE_PAGE_OR_SIZE',
  id,
  page_token: pageToken,
  page_size: pageSize,
});

export const changeFilter = (id, filter) => ({
  type: 'CHANGE_FILTER',
  id,
  filter,
});

export const setAdvancedSearchQuery = (id, query) => ({
  type: 'SET_ADVANCED_SEARCH_QUERY',
  id,
  query,
});

export const changeFilterQuery = (id, filterQuery) => ({
  type: 'CHANGE_FILTER_QUERY',
  id,
  filterQuery,
});

export const changeSorting = (id, sorting) => ({
  type: 'CHANGE_SORTING',
  id,
  sorting,
});

export const setTotalCount = (id, count) => ({
  type: 'SET_TOTAL_COUNT',
  id,
  count,
});

export const setForceUpdate = (id) => ({
  type: 'SET_FORCE_UPDATE',
  id,
});

export const resetPage = (id) => ({
  type: 'RESET_PAGE',
  id,
});

export const recalculateSortFilterWithColumns = (id, columns) => ({
  type: 'RECALCULATE_SORT_FILTER_WITH_COLUMNS',
  id,
  columns,
});

export const toggleSelectAll = (id) => ({
  type: 'SSP_TOGGLE_SELECT_ALL',
  id,
});

export const setAllSelected = (id) => ({
  type: 'SSP_SELECT_ALL',
  id,
});

export const setCurrentPageSelected = (id) => ({
  type: 'SSP_SELECT_ALL_CURRENT_PAGE',
  id,
});

export const deselectAll = (id) => ({
  type: 'SSP_DESELECT_ALL',
  id,
});

export const closeSSP = (id) => ({
  type: 'SSP_CLOSE',
  id,
});

export const setActiveRow = (id, itemId) => ({
  type: 'SSP_SET_ACTIVE_ITEM',
  id,
  itemId,
});
export const addOrUpdateItem = (id, item, accessor) => ({
  type: 'ADD_OR_UPDATE_ITEM',
  id,
  item,
  accessor,
});

export const onPageSizeChange =
  (id, { page_token: pageToken, page_size: pageSize }) =>
  (dispatch) => {
    dispatch(changePageOrSize(id, pageToken, pageSize));
  };

export const onFilterChange =
  (id, { filter_by: filterBy }) =>
  (dispatch) =>
    dispatch(changeFilter(id, filterBy));

export const onSortChange =
  (id, { sorting }) =>
  (dispatch) =>
    dispatch(changeSorting(id, sorting));
